import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import BrandName from '../BrandName';
import { DiscoveryHeading } from './DiscoveryCard';
import content from '../../data/collection-showcases.json';
import taxonomy from '../../data/discovery-taxonomy.json';

export function CollectionTab({ collections }) {
  const ordered=[...collections].sort((a,b)=>taxonomy.collections.indexOf(a.slug)-taxonomy.collections.indexOf(b.slug));
  return <><DiscoveryHeading>Lighting collections</DiscoveryHeading>
    <div className="balanced-grid discovery-grid discovery-wide" data-testid="discovery-collection-grid">
      {ordered.map(item=><Link key={item.slug} to={item.url} data-testid={`collection-card-${item.slug}`} className="no-underline group block min-w-0 border border-border rounded-md bg-white overflow-hidden hover:border-foreground/40 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4">
        <div data-testid={`collection-logo-${item.slug}`} role="img" aria-label={`${item.name} logo`} className="aspect-[4/3] flex items-center justify-center p-3 sm:p-6 bg-muted/10">
          <BrandName name={item.name} className="text-base sm:text-xl lg:text-2xl whitespace-nowrap font-satoshi" />
        </div>
        <div className="p-3 sm:p-4 border-t border-border/50">
          <p data-testid={`collection-purpose-${item.slug}`} className="text-xs text-muted-foreground leading-relaxed min-h-[3em]">{content[item.slug]?.category}</p>
          <div className="flex justify-between items-center mt-4 text-xs"><span data-testid={`collection-count-${item.slug}`}>{item.product_count} families</span><ArrowUpRight className="h-4 w-4" /></div>
        </div>
      </Link>)}
    </div></>;
}